import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/content';
import PosterCard from '@/components/base/PosterCard';

export default function HotEntertainment({ items }: { items: ContentItem[] }) {
  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门娱乐推荐</h2>
            <p className="mt-1.5 text-sm text-foreground-600">影视预告与明星动态，精彩不容错过</p>
          </div>
          <Link
            to="/entertainment"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4 md:gap-5 lg:grid-cols-4">
          {items.map((item) => (
            <PosterCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}